export const AktiGroteskRegular = {
  src: `url(https://cdn.ownup.com/component-library/latest/AktivGrotesk_W_Rg.woff),
        url(https://cdn.ownup.com/component-library/latest/AktivGrotesk_W_Rg.woff2)`
};
